const departments = {
    finance: '財務',
    marketing: 'マーケティング',
    engineering: 'エンジニアリング',
    humanResources: '人事',
    sales: '営業',
    operations: 'オペレーション',
    legal: '法務',
    executive: '経営',
  };

export default departments;
